import { render, staticRenderFns } from "./OrderItemDetailsModal.vue?vue&type=template&id=6f79ecd3&"
import script from "./OrderItemDetailsModal.ts?vue&type=script&lang=js&"
export * from "./OrderItemDetailsModal.ts?vue&type=script&lang=js&"
import style0 from "./OrderItemDetailsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports